<p-floatLabel>
  <p-select #serviceEntrySheetStateDropdownComponent
            id="serviceEntrySheetStateDropdownComponent"
            name="serviceEntrySheetStateDropdownComponent"
            [options]="serviceConfigurationStates"
            [(ngModel)]="serviceConfigurationState"
            [showClear]="!isRequired"
            [checkmark]="true"
            styleClass="w-100"
            (onChange)="onSelected()">
    <ng-template let-option pTemplate="item">
      {{ option.label }}
    </ng-template>
  </p-select>
  <label for="serviceEntrySheetStateDropdownComponent">
    <app-label-content [isRequired]="isRequired">
      {{ l('::State') }}
    </app-label-content>
  </label>
</p-floatLabel>
